import { render, staticRenderFns } from "./Utilities-Detail-Sparepart.vue?vue&type=template&id=079c98d0"
import script from "./Utilities-Detail-Sparepart.vue?vue&type=script&lang=js"
export * from "./Utilities-Detail-Sparepart.vue?vue&type=script&lang=js"
import style0 from "./Utilities-Detail-Sparepart.vue?vue&type=style&index=0&id=079c98d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports